var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Publish",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D-/-C-/-Publish_1.1",
    transform: "translate(-324.000000, -326.000000)",
    fill: "#27DE81",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a\\xF1adir",
    transform: "translate(16.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(16.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uDBC0\\uDD88",
    transform: "translate(292.398438, 0.109375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,16.5078125 C12.78125,16.5078125 16.5,12.78125 16.5,8.25 C16.5,3.7265625 12.7734375,0 8.25,0 C3.71875,0 0,3.7265625 0,8.25 C0,12.78125 3.7265625,16.5078125 8.25,16.5078125 Z M4.421875,8.25 C4.421875,7.71875 4.8046875,7.328125 5.328125,7.328125 L7.328125,7.328125 L7.328125,5.328125 C7.328125,4.8046875 7.71875,4.4140625 8.25,4.4140625 C8.78125,4.4140625 9.171875,4.8046875 9.171875,5.328125 L9.171875,7.328125 L11.1796875,7.328125 C11.6953125,7.328125 12.0859375,7.71875 12.0859375,8.25 C12.0859375,8.78125 11.6953125,9.171875 11.1796875,9.171875 L9.171875,9.171875 L9.171875,11.171875 C9.171875,11.6953125 8.78125,12.078125 8.25,12.078125 C7.71875,12.078125 7.328125,11.6953125 7.328125,11.171875 L7.328125,9.171875 L5.328125,9.171875 C4.8046875,9.171875 4.421875,8.78125 4.421875,8.25 Z",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.33ba1b2ef705f8b3513d47aab14ff5f2.svg";
export { ForwardRef as ReactComponent };